module.exports = __webpack_public_path__ + "img/topbrands.ccbd19ad.jpg";